import img_1101EGG from './1101EGG.png';
import img_1102EGG from './1102EGG.png';

export const edelstahlgelaender_glas = [
    {product_img: img_1101EGG, titel: 'Modell - 1101EGG'},
    {product_img: img_1102EGG, titel: 'Modell - 1102EGG'}
]